import { AggregationSuffix, CounterNames } from '../constants';

export function getCounter({ name }) {
  return {
    name: name,
    aggregation: getCounterAggregation(name)
  };
}

export function getCounterAggregation(name) {
  if (!name) return 'avg'
  if (name === CounterNames.SYSTEM_UP_TIME) return 'max'

  const matchedAggregation = name.match(/-(min|max)$/); // eg. PanelPower_HPolDL-max
  if (matchedAggregation) return parseAggregation(matchedAggregation[1])

  return 'avg'
}

function parseAggregation(aggregation) {
  if (aggregation === 'min' || aggregation === 'max') return aggregation;
  return 'avg';
}
